export interface IHistogeneticsCryoReceived {
    id: number,
    type: string,
    donorAlias: string,
    donorFirstName: string,
    donorLastName: string,
    orderDateTime: string
}
